module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-05-7d003c62d28ce59b8c372b4d690ffcba.jpg";